import React, { Component, useEffect, useState } from "react";
import {
    DKLabel,
    DKLine,
    DKIcon

} from "deskera-ui-library";
import Utility from "../../utility/Utility";
import moment from "moment";
import { getCompensationInPerMonth, getCompensationStringType, getFormattedAmount, getSelectedIdFromObject, isEffectiveSalaryApplied, isIndiaCompliance } from "../../managers/common/CommonUtil";
import { selectTenanatData } from "../../Redux/Slices/EmployeeListSlice";
import { useSelector } from "react-redux";
import { CONSTANTS, FORMAT, INPUT_TYPE } from "../../constants/Constant";
import { useTranslation } from "react-i18next";
import { TENANT, TenantService } from "../../managers/TenantManagerService";
import MaskInputUtil from "../../SharedComponents/MaskInput/MaskInputUtil";
import PermissionUtils from "../user-permissions/PermissionUtils";
import ic_info_warning from "../../assets/icons/ic_info_gray.svg";


const RightPanel = (props) => {
    const { t, i18n } = useTranslation();
    const selfView = props.userId === TenantService.get(TENANT.USER_ID);

    const [employeeDetails, setEmployeeDetails] = useState(props.data);
    const [stage, setStage] = useState(props.stage);
    const [componentDetails, setComponentDetails] = useState(props.components);
    const tenantData = useSelector(selectTenanatData);
    const [columnConfig, setColumnConfig] = useState([]);
    const [componentValues, setComponentValues] = useState({});
    const [ComponentList, setComponentList] = useState([]);
    const [estimate, setEstimate] = useState();

    useEffect(() => {
        if (!Utility.isEmpty(props.data)) {
            setEmployeeDetails(props.data);
        }
    }, [props.data])

    useEffect(() => {
        if (!Utility.isEmpty(props.components)) {
            setComponentDetails(props.components);
            const columnConfigs = [
              ...props.components.fixedComponentColumnConfig,
              ...props.components.variableComponentColumnConfig,
              ...props.components.benefitComponentColumnConfig,
            ];
            const defaultValues = {
              ...props.components.componentDefaultValues,
              ...props.components.componentDefaultValuesVariable,
              ...props.components.componentDefaultValuesBenefit,
            };
            setColumnConfig(columnConfigs);
            setComponentValues(defaultValues);
            componentView(columnConfigs, defaultValues);

        }

    }, [props.components]);

    useEffect(() => {
            // let a = deepClone(props.componentsList)
            let componentsArr = [];
            let count = 0;
            const compensationPeriod =
              employeeDetails && employeeDetails.compensationPeriod
                ? employeeDetails.compensationPeriod
                : "";
            if (!isIndiaCompliance() && compensationPeriod === "365") {
              count =
                employeeDetails && employeeDetails.compensation
                  ? employeeDetails.compensation / 12
                  : 0;
            } else if (!isIndiaCompliance()) {
              count =
                employeeDetails && employeeDetails.compensation
                  ? employeeDetails.compensation
                  : 0;
            }
            if (!Utility.isEmpty(props.componentsList)) {
              props.componentsList.forEach((config) => {
                if (!Utility.isEmpty(config.componentId)) {
                  let obj = {
                    componentName: config.name,
                    componentType:
                      config.type == "EARNING" ? "Earning" : "Deduction",
                    amount: parseFloat(config.amount),
                  };
                  if (obj.componentType == "Earning") {
                    count = count + obj.amount;
                  } else {
                    count = count - obj.amount;
                  }
                  componentsArr.push(obj);
                }
              });
            }
            if (!Utility.isEmpty(props.benefitsList)) {
              props.benefitsList &&
                props.benefitsList.forEach((element) => {
                  let obj = {
                    componentName: element.name,
                    componentType: CONSTANTS.BENEFITS,
                    amount: element.employeeDeductionAmount
                      ? getCurrencyAmount(element)
                      : 0,
                  };
                  count = count - obj.amount;
                  componentsArr.push(obj);
                });
            }
            setComponentList(componentsArr);
            setEstimate(getFormattedAmount(count));
    }, [props.componentsList, props.benefitsList]);

    const componentView = (columnConfig, componentValues) => {
        let componentsArr = [];
        let count = 0;
        const compensationPeriod = employeeDetails && employeeDetails.compensationPeriod ? employeeDetails.compensationPeriod : "";
        if (!isIndiaCompliance() && compensationPeriod === "365") {
          count = employeeDetails && employeeDetails.compensation
              ? employeeDetails.compensation / 12
              : 0;
        } else if(!isIndiaCompliance()) {
          count = employeeDetails && employeeDetails.compensation
              ? employeeDetails.compensation : 0;
        }
        columnConfig.forEach(config => {
            if (!Utility.isEmpty(config && config.id)) {
                let obj = {
                  componentName: config.componentName,
                  componentType:
                    config.componentType == CONSTANTS.EARNING
                      ? "Earning"
                      : config.componentType == CONSTANTS.BENEFIT
                      ? "Benefit"
                      : "Deduction",
                  amount: parseFloat(
                    config.componentType != CONSTANTS.BENEFIT &&
                      componentValues[config.columnCode] &&
                      componentValues[config.columnCode].amount
                      ? componentValues[config.columnCode].amount
                      : config.componentType === CONSTANTS.BENEFIT &&
                        componentValues[config.columnCode] &&
                        componentValues[config.columnCode]
                          .employeeDeductionAmount
                      ? getCurrencyAmount(componentValues[config.columnCode])
                      : 0
                  ),
                };
                if (obj.componentType == "Earning") {
                  count = count + obj.amount;
                } else if (obj.componentType == CONSTANTS.BENEFITS) {
                  count = count - obj.amount;
                } else {
                  count = count - obj.amount;
                }
                componentsArr.push(obj);
            }
        })


        setComponentList(componentsArr);
        setEstimate(getFormattedAmount(count));
    }

    const getCurrencyAmount = (benefit) => {
    if (benefit.employeeDeductionType == CONSTANTS.PERCENT) {
      let finalCompensation = 0;
      let details = employeeDetails;
      let compensationPeriod = details.compensationPeriod ? details.compensationPeriod : "";
      let compensation = details.compensation ? details.compensation : "";
      if (compensationPeriod === '365') {
        finalCompensation = compensation ? compensation / 12 : 0;
      } else {
        finalCompensation = compensation ? compensation : 0;
      }
      const amount = (finalCompensation * benefit.employeeDeductionAmount) / 100;
      return amount;
    } else {
      return benefit.employeeDeductionAmount;
    }

  }
    const getComponentSection = () => {
        let rows = ComponentList.map(data => {
            return (
                <tr className="m-v-s fw-m">
                    <td className="d-flex">
                        <span className={`p-v-s p-h-m border-radius-l border-m  ${(data.componentType == 'Earning' ? 'earning' : 'deduction')}`} >
                            {data.componentType}
                        </span>
                    </td>
                    <td style={{ width: '75%' }}>
                        <div className="d-flex justify-content-between pl-s">
                            <span className="text-gray">{data.componentName}</span>
                            <span>{PermissionUtils.showMaskedAmount(MaskInputUtil.getMaskedNumber(props.mask, data.amount), selfView)}</span>
                        </div></td>
                </tr>)
        })
        return (
            <div className="parent-width">
                <DKLabel text={t("COMPONENT")}
                    className="fw-m fs-xl"
                />
                <table className="parent-width" style={{
                    borderCollapse: 'separate', borderSpacing: '0px 1em'
                }}>
                    {rows}
                </table>
                <DKLine
                    className="bg-gray3 m-v-s"
                />
            </div>
        )
    }

    const getCompensationAmountAndPeriod = () => {
        let compensationAmount = 0;
        let compensationPeriod = "";
        let conpensationField = isIndiaCompliance() ? "ctc": "compensation"
        if(employeeDetails && stage != 0) {
            compensationAmount =
              isIndiaCompliance() && employeeDetails.ctc
                ? employeeDetails.ctc
                : employeeDetails.compensation;
            compensationPeriod = employeeDetails.compensationPeriod ? employeeDetails.compensationPeriod:"";
            if (employeeDetails.isEffectiveSalary) {
                let effectiveCompensationsArray = employeeDetails.effectiveCompensations;
                let visibleCompensation = effectiveCompensationsArray.find(x => x.isVisible);
                let isEffectiveSalaryApplicable = isEffectiveSalaryApplied(
                  employeeDetails.isEffectiveSalary, visibleCompensation
                );
                if (isEffectiveSalaryApplicable) {
                    compensationAmount = visibleCompensation.compensation;
                    if (compensationAmount) {
                      if (typeof compensationAmount === CONSTANTS.STRING) {
                        compensationAmount = parseFloat(compensationAmount);
                      } else if (typeof compensationAmount === INPUT_TYPE.NUMBER) {
                        compensationAmount = compensationAmount;
                      }
                    } else {
                      compensationAmount = 0;
                    }
                    compensationPeriod = visibleCompensation.period;
                    employeeDetails[conpensationField] = compensationAmount;
                    employeeDetails["compensationPeriod"] = compensationPeriod;
                }
            }
        } else if( employeeDetails && stage === 0) {
            compensationAmount =
              employeeDetails.ctc && employeeDetails.ctc
                ? employeeDetails.ctc
                : employeeDetails.compensation;
            compensationPeriod = employeeDetails.period ? getSelectedIdFromObject(employeeDetails.period, "id"): "";
            if (employeeDetails.isEffectiveSalary) {
                let isEffectiveSalaryApplicable = isEffectiveSalaryApplied(
                  employeeDetails.isEffectiveSalary, employeeDetails
                );
                if (isEffectiveSalaryApplicable) {
                    compensationAmount = employeeDetails.defaultCompensation;
                    if (compensationAmount) {
                      if (typeof compensationAmount === CONSTANTS.STRING) {
                        compensationAmount = parseFloat(compensationAmount);
                      } else if (typeof compensationAmount === INPUT_TYPE.NUMBER) {
                        compensationAmount = compensationAmount;
                      }
                    } else {
                      compensationAmount = 0;
                    }
                    compensationPeriod = getSelectedIdFromObject(
                      employeeDetails.effectivePeriod,
                      "id"
                    );
                }
            }
            employeeDetails[conpensationField] = compensationAmount;
            employeeDetails["compensationPeriod"] = compensationPeriod;

        }

        return employeeDetails[conpensationField];

    }

    const getAmount = () => {
        return getFormattedAmount(employeeDetails.ctc);
    }

    const getEstimatedAmount = () => {
        let amount = 0;
        let compensation = isIndiaCompliance()
          ? employeeDetails.ctc
          : employeeDetails.compensation;
        amount = getCompensationInPerMonth(
          employeeDetails.compensationPeriod,
          compensation,
          tenantData.tenant?.workWeekDetails,
          employeeDetails
        );
        if(stage === 1) {
            if (employeeDetails && employeeDetails.benefits) {
              employeeDetails.benefits.forEach((element) => {
                amount -= element.employeeDeductionAmount
                  ? getCurrencyAmount(element)
                  : 0;
              });
            }
            if (employeeDetails && employeeDetails.components) {
              employeeDetails.components.forEach((element) => {
                if(element.type === CONSTANTS.DEDUCTION.toUpperCase()){
                  amount -= element.amount ? element.amount : 0
                }
              })
            }
        }
        return amount;
    }

    return (
        <>
            <DKLabel
                text="EMPLOYEE COMPENSATION SUMMARY "
                className="text-gray fw-m"
            />
            <DKLine
                className="bg-gray3 m-v-s"
            />
            <div className="p-v-m">
                <div className="d-flex justify-content-between">
                    <DKLabel
                        text={t(TenantService.get(TENANT.CUSTOM_FIELD_SECTION_ENABLED) ? "PW_BASIC_SALARY":"BASIC_SALARY")}
                        className="fw-m fs-xl" />
                    <DKLabel
                        text={employeeDetails ? PermissionUtils.showMaskedAmount(MaskInputUtil.getMaskedNumber(props.mask, getCompensationAmountAndPeriod()), selfView) : ''}
                        className="fw-m fs-xl"
                    />
                </div>
                <div className="d-flex justify-content-end">
                    <DKLabel text={`/ ${employeeDetails ? getCompensationStringType(employeeDetails.compensationPeriod) : ''}`} className="  fs-r text-gray" />
                </div>
            </div>
            <DKLine
                className="bg-gray3 m-v-s"
            />
            <div className="p-v-m">
                {(ComponentList && ComponentList.length != 0) && getComponentSection()}
            </div>

            {employeeDetails && 
            (!isIndiaCompliance() ? getCompensationStringType(employeeDetails.compensationPeriod) != CONSTANTS.HOUR : true ) &&
            getCompensationStringType(employeeDetails.compensationPeriod) != CONSTANTS.WEEK && (
              <>
              <div className="p-v-m">
                <div className="d-flex justify-content-end">
                    {(stage != 0 && employeeDetails && !estimate) && <DKLabel text={PermissionUtils.showMaskedAmount(MaskInputUtil.getMaskedNumber(props.mask, getEstimatedAmount()), selfView)} className="fw-m fs-xxxl" />}
                    {stage != 0 && estimate && <DKLabel text={PermissionUtils.showMaskedAmount(MaskInputUtil.getMaskedNumber(props.mask, estimate), selfView)} className="fw-m fs-xxxl" />}
                    {stage === 0 && <DKLabel text={PermissionUtils.showMaskedAmount(MaskInputUtil.getMaskedNumber(props.mask, getEstimatedAmount()), selfView)} className="fw-m fs-xxxl" />}

                </div>
                <div className="d-flex justify-content-end">
                    <DKLabel
                        className="fw-m fs-xl"
                        text="Estimate"
                    />

                </div>
                <div className="d-flex justify-content-end">
                    <DKLabel
                        className="fw-m fs-r text-gray"
                        text={String().concat(Utility.formatDate(moment().startOf('month').format(FORMAT.DDMMYYYY), FORMAT.DDMMYYYY), ' - ', Utility.formatDate(moment().endOf('month').format(FORMAT.DDMMYYYY), FORMAT.DDMMYYYY))}
                    />
                </div>
              </div>
              <div>
              <DKLine
                className="bg-gray3 m-v-s"
              />
              { (isIndiaCompliance() && props.stepIndex===1) &&
                getCompensationStringType(employeeDetails.compensationPeriod) === CONSTANTS.HOUR &&
                <span 
                className="row padding-bottom-mobile parent-width"
              >
                <DKIcon src={ic_info_warning} className="ic-s mr-r" />
                <DKLabel
                  className="mt-xs"
                  text="Component amounts are extrapolated for current month, based on configured hourly wage and default hours per day "
                />
              </span>}
            </div>
            </>
            )}
        </>
    )
}

export default RightPanel;